var React = require('react');

function Warning (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M8.00016 2.3335C11.4055 2.3335 14.1668 5.09416 14.1668 8.50016C14.1668 11.9055 11.4055 14.6668 8.00016 14.6668C4.59416 14.6668 1.8335 11.9055 1.8335 8.50016C1.8335 5.09416 4.59416 2.3335 8.00016 2.3335Z","stroke":"#FF0033","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M7.99707 5.96973V8.91573","stroke":"#FF0033","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M7.99658 11.0308H8.00325","stroke":"#FF0033","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

Warning.defaultProps = {"width":"16","height":"17","viewBox":"0 0 16 17","fill":"none"};

module.exports = Warning;

Warning.default = Warning;
